var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "EmptyContent",
    {
      attrs: { icon: "icon-calendar-dark" },
      scopedSlots: _vm._u([
        {
          key: "desc",
          fn: function() {
            return [
              _vm._v(
                "\n\t\t" +
                  _vm._s(
                    _vm.$t(
                      "calendar",
                      "Maybe the share was deleted or has expired?"
                    )
                  ) +
                  "\n\t"
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(
        "\n\t" +
          _vm._s(_vm.$t("calendar", "Public calendar does not exist")) +
          "\n\t"
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }